export const VISIONARIES_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    profile_name: "Name",
    profile_title: "Title",
    priority: 1,
  },

  VISIONARIES_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "Pre title",
      value: "Led by Visionaries,",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 50 characters",
      required: false,
      defaultValue: "Led by Visionaries,",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Built for You",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 50 characters",
      required: false,
      defaultValue: "Built for You",
    },
    {
      fieldName: "title_start_color",
      label: "Title gradient start",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title gradient end",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title gradient angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop background color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile background color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "backvariant",
      label: "Background variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient color 1",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient color 4",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left navigation icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right navigation icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "progress_track_color",
      label: "Progress track color",
      value: "#444444",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#444444",
    },
    {
      fieldName: "progress_fill_color",
      label: "Progress fill color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "use_categories",
      label: "Show Category Tabs",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Scroll reveal on section content",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_coverflow_carousel",
      label: "Enable Coverflow Carousel",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "3D coverflow carousel; turn off for the classic horizontal strip with arrows",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 50 characters",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Tab text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "border_color",
      label: "Tab border color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Tab background",
      value: "transparent",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "transparent",
    },
    {
      fieldName: "active_text_color",
      label: "Active tab text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "active_background_color",
      label: "Active tab background",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "active_border_color",
      label: "Active tab border",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "order_index",
      label: "Display order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "is_active",
      label: "Category status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "is_default",
      label: "Default (all pool visionaries)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  PROFILE_TABLE_FIELDS_CONFIG: [
    {
      header: "Name",
      fieldName: "profile_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 50 characters",
      required: true,
    },
    {
      header: "Title",
      fieldName: "profile_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 50 characters",
      required: false,
    },
    {
      header: "Name color",
      fieldName: "profile_name_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Title color",
      fieldName: "profile_title_color",
      value: "#CCCCCC",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Desktop image",
      fieldName: "desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: true,
    },
    {
      header: "Mobile image",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: true,
    },
    {
      header: "Image alt",
      fieldName: "image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Card overlay gradient start",
      fieldName: "card_overlay_gradient_start",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card overlay gradient end",
      fieldName: "card_overlay_gradient_end",
      value: "#00000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card overlay gradient angle",
      fieldName: "card_overlay_gradient_angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logo 1",
      fieldName: "logo_1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Logo 1 alt",
      fieldName: "logo_1_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logo 2",
      fieldName: "logo_2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
    },
    {
      header: "Logo 2 alt",
      fieldName: "logo_2_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
    },
    {
      header: "Logos layout",
      fieldName: "logos_layout",
      value: "row_center",
      valueType: "string",
      filedType: "SELECT",
      options: [
        { label: "Row center", value: "row_center" },
        { label: "Stack", value: "stack" },
      ],
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
    },
    {
      header: "Active",
      fieldName: "is_active",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
    },
  ],
};
